// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DashboardAuth from './components/DashboardAuth';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if we're on the admin page based on URL path
const isAdminPage = window.location.pathname === '/admin' ||
                     window.location.pathname === '/admin/';

// Render either the admin dashboard or the main app
root.render(
  <React.StrictMode>
    {isAdminPage ? <DashboardAuth /> : <App />}
  </React.StrictMode>
);

reportWebVitals();